import React, { useEffect, useState, useMemo } from 'react'
import { useDropzone } from 'react-dropzone'
import AdapterJalali from '@date-io/date-fns-jalali'
import * as Yup from 'yup'

import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Box,
  InputAdornment,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Typography,
} from '@mui/material'
import {
  LoadingButton,
  DesktopDatePicker,
  MobileDatePicker,
  LocalizationProvider,
} from '@mui/lab'

import FileUpload from './FileUpload'
import Iconify from './Iconify'

import uploadService from '../services/upload'

import { useFormik, Form, FormikProvider } from 'formik'

export default function TicketCreateDialog({ open, onClose, onClick }) {
  const [ticketLevel, setTicketLevel] = useState('NORMAL')
  const [ticketFile, setTicketFile] = useState({
    url: '',
    uploading: false,
  })

  const TicketSchema = Yup.object().shape({
    title: Yup.string().required('عنوان الزامی می باشد'),
    message: Yup.string().required('پیام الزامی می باشد'),
  })

  const formik = useFormik({
    initialValues: {
      title: '',
      message: '',
      level: '',
    },
    validationSchema: TicketSchema,
    onSubmit: (values, actions) => {
      setTimeout(() => {
        values.level = ticketLevel
        onClick(values)
        actions.setSubmitting(false)
        resetForm()
      }, 500)
    },
  })

  const handleChangeTicketLevel = (e) => {
    setTicketLevel(e.target.value)
  }

  const onTicketFileDrop = async (acceptedFiles) => {
    try {
      setTicketFile({ uploading: true })

      const file = acceptedFiles[0]
      const url = await uploadService(file)

      setTicketFile({ url, uploading: false })
    } catch (error) {
      console.log(error)
    }
  }

  const onTicketFileDelete = () => {
    setTicketFile({ url: '' })
  }

  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    resetForm,
  } = formik

  return (
    <div>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
        <DialogTitle>ارسال تیکت</DialogTitle>
        <DialogContent>
          <FormikProvider value={formik}>
            <Form
              id='ticket-form'
              autoComplete='off'
              noValidate
              onSubmit={handleSubmit}
            >
              <Grid
                container
                spacing={2}
                columns={{ xs: 4, sm: 8, md: 12 }}
                sx={{
                  marginTop: 0,
                }}
              >
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label='عنوان'
                    variant='outlined'
                    {...getFieldProps('title')}
                    error={Boolean(touched.title && errors.title)}
                    helperText={touched.title && errors.title}
                    type='search'
                    autoComplete='off'
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor='max-width'>وضعیت</InputLabel>
                    <Select
                      autoFocus
                      label='وضعیت'
                      value={ticketLevel}
                      onChange={(e) => handleChangeTicketLevel(e)}
                    >
                      <MenuItem value='NORMAL'>عادی</MenuItem>
                      <MenuItem value='IMPORTANT'>مهم</MenuItem>
                      <MenuItem value='URGENT'>خیلی مهم</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  {/* <TextField
                      fullWidth
                      autoComplete='off'
                      type='text'
                      {...getFieldProps('description')}
                      error={Boolean(touched.description && errors.description)}
                      helperText={touched.description && errors.description}
                      multiline
                      rows={4}
                      label='پیام'
                    /> */}

                  <TextField
                    fullWidth
                    label='پیام'
                    variant='outlined'
                    {...getFieldProps('message')}
                    error={Boolean(touched.message && errors.message)}
                    helperText={touched.message && errors.message}
                    multiline
                    rows={4}
                    type='search'
                    autoComplete='off'
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ width: 1 }}>
                    <FileUpload
                      uploading={ticketFile.uploading}
                      onDrop={onTicketFileDrop}
                      file={ticketFile.url}
                      buttonText='آپلود فایل'
                      onDelete={onTicketFileDelete}
                      isDialog
                      small
                    />
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            form='ticket-form'
            type='submit'
            variant='contained'
            loading={isSubmitting}
          >
            ایجاد
          </LoadingButton>

          <Button
            onClick={onClose}
            variant='contained'
            sx={[
              {
                backgroundColor: '#E75C25',
              },
              {
                '&:hover': {
                  backgroundColor: '#E75C25',
                },
              },
            ]}
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
